import gql from 'graphql-tag';

export default gql`
  mutation updateLastBookingStepCompleted($step: BookingStepCompleted) {
    updateLastBookingStepCompleted(step: $step) {
      step
      errors
    }
  }
`;
